"use client";

import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { SessionProvider } from "next-auth/react";
import { Next13ProgressBar } from 'next13-progressbar';
import { ThemeProvider } from "./theme-provider";

const queryClient = new QueryClient()

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
        >
          <Next13ProgressBar height="3px" color="#0A2FFF" options={{ showSpinner: false }} showOnShallow />

          {children}
        </ThemeProvider>
      </SessionProvider>
    </QueryClientProvider>
  )
};
